import { EAnswerItemType } from '#models/layout';
import { Answer } from '#models/questionnaire';
import { PictureEvenAnswer } from '#modules/PictureEvenAnswer';
import { PictureOddAnswer } from '#modules/PictureOddAnswer';
import { useMediaQuery, useTheme } from '@material-ui/core';
import * as React from 'react';

export interface PictureAnswerProps {
  answer: Answer;
  showHelperText: any;
  type?: EAnswerItemType;
  selected?: boolean;
  isEvenAnswer?: boolean;
  multipleSelection: boolean;
}

export const PictureAnswer = (props: PictureAnswerProps) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const showEvenAnswer = !isSmDown;

  return (
    <React.Fragment>
      {!showEvenAnswer && <PictureOddAnswer {...props} />}
      {showEvenAnswer && <PictureEvenAnswer {...props} />}
    </React.Fragment>
  );
};
